<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage">
<a id="title17"></a>
<div class="tp-title"><strong class="b">CAROLE MORTIMER</strong></div>
<div class="tp-subtitle"><strong class="b">To Woo a</strong> <strong class="b">Wife</strong></div>
<div class="illustype_image"><div class="image"><img alt="9781459251915_i0002.jpg" src="9781459251915_i0002.jpg"/></div></div>
<div class="p-c-br"><span><strong class="b">TORONTO • NEW YORK • LONDON</strong> <br/><strong class="b">AMSTERDAM • PARIS • SYDNEY • HAMBURG</strong> <br/><strong class="b">STOCKHOLM • ATHENS • TOKYO • MILAN • MADRID</strong> <br/><strong class="b">PRAGUE • WARSAW • BUDAPEST • AUCKLAND</strong></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459251915_tp01.vue?05e62db8